// utils/auth/permissions.js

// Which departments can access which sidebar module (matched by `key`)
export const DEPARTMENT_ACCESS = {
    // ADMIN bypasses this entirely
    INVENTORY: ['rawMaterial'],
    PRODUCT: ['product'],
    PORTFOLIO: ['portfolio'],
    OFFICE: ['office'],
    MARKETING: ['blog', 'lead'],
    PROJECT: ['project'],
    OPS: ['measureInstall'],
    ADMINISTRATION: ['users'],
};

// Check if a user can access a given module key
export const canAccessModule = (user, moduleKey) => {
    if (!user) return false;
    if (user.role === 'ADMIN') return true;
    if (user.role !== 'USER') return false;

    const allowedModules = DEPARTMENT_ACCESS[user.department] || [];
    return allowedModules.includes(moduleKey);
};

// Check if a user can access a specific route path
export const canAccessRoute = (user, path) => {
    if (!user) return false;
    if (user.role === 'ADMIN') return true;

    // Map route prefixes → module keys
    const ROUTE_MODULE_MAP = [
        { prefix: '/raw-material', key: 'rawMaterial' },
        { prefix: '/inventory', key: 'rawMaterial' },
        { prefix: '/products', key: 'product' },
        { prefix: '/create-product', key: 'product' },
        { prefix: '/product', key: 'product' },
        { prefix: '/category', key: 'product' },
        { prefix: '/filter', key: 'product' },
        { prefix: '/color', key: 'product' },
        { prefix: '/collection-partner', key: 'product' },
        { prefix: '/portfolio', key: 'portfolio' },
        { prefix: '/create-portfolio', key: 'portfolio' },
        { prefix: '/offices', key: 'office' },
        { prefix: '/create-office', key: 'office' },
        { prefix: '/blogs', key: 'blog' },
        { prefix: '/create-blog', key: 'blog' },
        { prefix: '/blog-categories', key: 'blog' },
        { prefix: '/leads', key: 'lead' },
        { prefix: '/projects', key: 'project' },
        { prefix: '/project-board', key: 'project' },
        { prefix: '/measurement-requests', key: 'measureInstall' },
        { prefix: '/portal-users', key: 'users' },
    ];

    for (const { prefix, key } of ROUTE_MODULE_MAP) {
        if (path.startsWith(prefix)) return canAccessModule(user, key);
    }
    // "/" is always accessible
    return path === '/';
};